export default __webpack_public_path__ + "static/media/espa.6c4e71c0.png";